<template>
    <div>
        <h1 
            class="fs-4 fw-bold text-dark mb-1 lh-sm"
        >
            Objetivo de optimización
        </h1>
        <p
            class="text-muted small fw-medium"
        >
            Define el objetivo de optimización para cada producto: ventas, margen, stock o competidores.
        </p>
        <TableObjectiveConfig 
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            @filterGoal="updateGoalFilter"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TableObjectiveConfig from './TableObjectiveConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigObjectiveOne from './configObjectiveOne.vue';
import ConfigObjectiveOptions from './configObjectiveOptions.vue';

export default {
    name: 'config-objective',
    mixins: [configsRecModuleMixin],
    components: {
        TableObjectiveConfig,
        ModalForm,
        ConfigObjectiveOne,
        ConfigObjectiveOptions
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "objective",
                text : ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
            goalFilter: '',
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/products/list_config_objective/?${this.buildCommonParams()}&goal_filter=${this.goalFilter}`;
        },
        viewModal(row, name, title, text) {
            this.componentName = name;
            this.propForm.size = false
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component: this.componentName,
            }
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "objective",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
        updateGoalFilter(goal) {
            this.goalFilter = goal;
            this.fetchData();
        },
    }
}
</script>
